/**
 * Created by anatolij on 29.09.2026
 */

Placements.ENTRIES["royalLeagueTierChange"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 5,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_ROYAL_LEAGUE);
        return mission && mission.logic.hasNewTier();
    },

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_ROYAL_LEAGUE);

        cleverapps.focusManager.display({
            focus: "RoyalLeagueTierChange",
            action: function (f) {
                mission.logic.markTierShown();

                new RoyalLeagueTierWindow(mission);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};

Placements.ENTRIES["royalLeagueStageReward"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 1,

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_ROYAL_LEAGUE);

        if (!mission || !mission.logic.hasUnclaimedStages()) {
            return
        }

        cleverapps.focusManager.display({
            focus: "RoyalLeagueStageReward",
            actions: [
                function (f) {
                    Mission.createRewardWindow(mission.logic.claimStages(), mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                },

                function (f) {
                    new RoyalLeagueStagesWindow(mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            ]
        });
    }
};
